"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenSwitchBase = _interopRequireDefault(require("@8x8/oxygen-switch-base"));

var _StyledCheckbox = require("../styled/StyledCheckbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Checkbox = function Checkbox(props) {
  var theme = props.theme,
      testId = props.testId,
      id = props.id,
      label = props.label,
      value = props.value,
      name = props.name,
      infoBoxText = props.infoBoxText,
      isChecked = props.isChecked,
      isIndeterminate = props.isIndeterminate,
      isDisabled = props.isDisabled,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["theme", "testId", "id", "label", "value", "name", "infoBoxText", "isChecked", "isIndeterminate", "isDisabled", "onChange"]);

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_oxygenSwitchBase["default"], _extends({
    testId: testId,
    theme: theme,
    id: id,
    icon: /*#__PURE__*/_react["default"].createElement(_StyledCheckbox.CheckboxIconContainer, {
      hasLabel: !!label,
      isChecked: isChecked,
      isIndeterminate: isIndeterminate
    }, /*#__PURE__*/_react["default"].createElement(_StyledCheckbox.CheckboxIcon, {
      isChecked: isChecked,
      isDisabled: isDisabled,
      isIndeterminate: isIndeterminate
    })),
    label: label,
    value: value,
    name: name,
    infoBoxText: infoBoxText,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isIndeterminate: isIndeterminate,
    onChange: onChange
  }, rest)));
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  /**
   * Checkbox theme
   */
  theme: _propTypes["default"].object,

  /**
   * Checkbox test id
   */
  testId: _propTypes["default"].string,

  /**
   * Value for `id` input attribute and `htmlFor` label attribute
   * @default: autogenerated
   */
  id: _propTypes["default"].string,

  /**
   * Specifies the label content for the checkbox input (text or custom component)
   */
  label: _propTypes["default"].node,

  /**
   * Checkbox input value
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })]),

  /**
   * Specifies the name prop for the checkbox input
   */
  name: _propTypes["default"].string,

  /**
   * Shows info icon and renders text inside Tooltip
   */
  infoBoxText: _propTypes["default"].node,

  /**
   * Specifies if the checkbox is checked
   */
  isChecked: _propTypes["default"].bool,

  /**
   * Specifies if the checkbox is disabled
   */
  isDisabled: _propTypes["default"].bool,

  /**
   * Specifies if the checkbox has indeterminate state
   */
  isIndeterminate: _propTypes["default"].bool,

  /**
   * Callback for the checkbox input
   */
  onChange: _propTypes["default"].func
};
Checkbox.defaultProps = {
  theme: {},
  testId: 'CHECKBOX',
  id: undefined,
  label: null,
  value: '',
  name: undefined,
  infoBoxText: undefined,
  isChecked: false,
  isDisabled: false,
  isIndeterminate: false,
  onChange: function onChange() {
    return false;
  }
};

var _default = (0, _oxygenConfig.withTheme)(Checkbox, 'checkbox');

exports["default"] = _default;